import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./FullReviews.scss";
import star from "../../Components/images/star.svg";
import leftArrowWhite from "../../Components/images/assets/left-arrow-white.svg";
import rightArrowWhite from "../../Components/images/assets/right-arrow-white.svg";
import { LuBadgeCheck } from "react-icons/lu";
import { LoadingStateCard } from "../../Components/LoadingStateCard/LoadingStateCard";

import { API_BASE_URL } from '../../config';
import { reviewImageUrls } from '../../utils/mediaUrl';
const BASE_URL = API_BASE_URL;

function ensureImageUrl(img) {
    if (!img || typeof img !== "string") return img;
    return img.startsWith("http") ? img : `${BASE_URL}/${img.replace(/^\//, "")}`;
}

const RATING_LABELS = { 5: "Excellent", 4: "Very Good", 3: "Good", 2: "Not Bad", 1: "Bad" };

function ratingChipTier(rating) {
    const n = Number(rating);
    if (!Number.isFinite(n)) return "5";
    const x = Math.round(n);
    return String(Math.min(5, Math.max(1, x)));
}

export function MobFullReviews() {
    const { product_id } = useParams();
    const [ratingMeta, setRatingMeta] = useState(null);
    const [modalImages, setModalImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [imageModalOpen, setImageModalOpen] = useState(false);
    const [modalImagesList, setModalImagesList] = useState([]);
    const [modalCurrentIndex, setModalCurrentIndex] = useState(0);

    useEffect(() => {
        if (!product_id) {
            setLoading(false);
            return;
        }
        let cancelled = false;
        const token = localStorage.getItem("token");
        const config = { headers: token ? { Authorization: `Bearer ${token}` } : {} };

        Promise.all([
            axios.post(`${BASE_URL}/products/ratings-meta/${product_id}`, { page: 1, size: 30 }, config),
            axios.post(`${BASE_URL}/products/modal-images/${product_id}`, { page: 1, size: 20 }, config),
        ])
            .then(([ratingsRes, modalsRes]) => {
                if (cancelled) return;
                const meta = ratingsRes.data;
                setRatingMeta(meta && !Array.isArray(meta) ? meta : null);
                setModalImages(Array.isArray(modalsRes.data) ? modalsRes.data : []);
            })
            .catch((err) => {
                if (!cancelled) {
                    setRatingMeta(null);
                    setModalImages([]);
                    console.error("MobFullReviews fetch error:", err);
                }
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });

        return () => { cancelled = true; };
    }, [product_id]);

    const allPhotosFlat = useMemo(() => {
        const fromModal = (modalImages || []).flatMap((r) => reviewImageUrls(r?.images));
        if (fromModal.length) return fromModal;
        return (ratingMeta?.reviews_data || []).flatMap((r) => reviewImageUrls(r?.images));
    }, [modalImages, ratingMeta]);
    const totalPhotos = allPhotosFlat.length;
    const total = ratingMeta?.total_ratings_count ?? 0;
    const specific = ratingMeta?.specific_rating_count ?? {};
    const getCount = (starLevel) => {
        if (Array.isArray(specific)) return specific[starLevel - 1] ?? 0;
        return specific[String(starLevel)] ?? specific[starLevel] ?? 0;
    };
    const count5 = getCount(5);
    const count4 = getCount(4);
    const count3 = getCount(3);
    const count2 = getCount(2);
    const count1 = getCount(1);
    const reviews = ratingMeta?.reviews_data ?? [];
    const progressPct = (count, tot) => (tot > 0 ? `${(count / tot) * 100}%` : "0%");

    const openImageModal = (imagesList, index) => {
        setModalImagesList(imagesList);
        setModalCurrentIndex(index);
        setImageModalOpen(true);
    };
    const closeImageModal = () => setImageModalOpen(false);
    const modalPrev = () => setModalCurrentIndex((i) => Math.max(0, i - 1));
    const modalNext = () => setModalCurrentIndex((i) => Math.min(modalImagesList.length - 1, i + 1));
    const modalCurrentUrl = modalImagesList[modalCurrentIndex] || null;
    const canModalPrev = modalCurrentIndex > 0;
    const canModalNext = modalCurrentIndex < modalImagesList.length - 1;

    if (!product_id) {
        return (
            <div className="mob-full-review-container">
                <div className="mob-reviews-ratings-container">
                    <p className="mob-reviews-empty-state">No product selected. Go back to a product to see reviews.</p>
                </div>
            </div>
        );
    }

    if (loading) {
        return (
            <div className="mob-full-review-container">
                <LoadingStateCard message="Loading reviews..." />
            </div>
        );
    }

    return (
        <div className="mob-full-review-container">
            {/* <div className="detailed-reviews-flexProduct">
                <div className="product-details-container">
                    <div className="product-details-imageWrapper" >
                        <div
                            className="product-details-image"
                            style={{backgroundImage: `url(${img1})`}}
                        ></div>
                        <div className="skeleton-skeletonLoader"></div>
                    </div>
                    <h1 className="product-details-brand">BULLMER</h1>
                    <h1 className="product-details-name undefined">
                        Graphic Printed Oversized Cotton T-shirt
                    </h1>
                    <p className="product-details-discountContainer">
                        <span className="product-details-price">
                            <strong>Rs. 389</strong>
                        </span>
                        <span className="product-details-mrp">
                            <s>Rs. 1499</s>
                        </span>
                        <span className="product-details-discount">(74% OFF)</span>
                    </p>
                </div>
            </div> */}

            <div className="mob-reviews-ratings-container">
                <div className="detailedRatingContainer design-4">
                    <div className="headingContainer">Ratings</div>
                    <div className="index-flexRow index-margin22 review-container">
                        <div className="index-flexColumn">
                            <div className="index-flexRow index-averageRating">
                                <span>{ratingMeta?.ratings_average ?? "–"}</span>
                                <span className="big-star"><img src={star} alt="" /></span>
                            </div>
                            <div className="index-countDesc">
                                {total > 0 ? `${total} Verified Buyers` : "No ratings yet"}
                            </div>
                        </div>
                        <div className="progress-container progress-variant-1">
                            {[5, 4, 3, 2, 1].map((level) => {
                                const count = level === 5 ? count5 : level === 4 ? count4 : level === 3 ? count3 : level === 2 ? count2 : count1;
                                return (
                                    <div key={level} className="index-flexRow index-ratingBarContainer">
                                        <span className="row-star" data-rating={String(level)}>
                                            <img src={star} alt="" />
                                        </span>
                                        <div className="index-rating">
                                            <span className="index-ratingLevel">{RATING_LABELS[level]}</span>
                                        </div>
                                        <div className="progress-wrapper" style={{ "--progress-percent": progressPct(count, total) }}>
                                            <progress
                                                min="0"
                                                max={total || 1}
                                                value={count}
                                                data-rating={String(level)}
                                            />
                                        </div>
                                        <div className="index-count">{count}</div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                <div className="thumbnails-container">
                    <div className="image-thumb-wrapper">
                        <div className="headline">Customer Photos ({totalPhotos})</div>

                        <div className="images-container">
                            {allPhotosFlat.length > 0 ? (
                                allPhotosFlat.slice(0, 4).map((url, i) => (
                                    <div
                                        key={i}
                                        className={`image-container${i === 3 && totalPhotos > 4 ? " image-container--has-more" : ""}`}
                                        onClick={() => openImageModal(allPhotosFlat, i)}
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(e) => e.key === "Enter" && openImageModal(allPhotosFlat, i)}
                                    >
                                        <div className="image">
                                            <img src={url} alt={`Customer ${i + 1}`} />
                                            {i === 3 && totalPhotos > 4 && (
                                                <span className="more-images-count">+{totalPhotos - 4} more</span>
                                            )}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p className="mob-reviews-empty-state">No customer photos yet</p>
                            )}
                        </div>
                    </div>

                    {/* <div className="image-only-modal-container">
                    <div className="modal-container">
                        <header>
                            <span>X</span>
                            All Customers Photos
                        </header>

                        <div className="images-wrapper">
                            <div className="image">
                                <img src={img1} alt="img1" />
                            </div>
                            <div className="image">
                                <img src={img1} alt="img1" />
                            </div>
                            <div className="image">
                                <img src={img1} alt="img1" />
                            </div>
                            <div className="image">
                                <img src={img1} alt="img1" />
                            </div>
                            <div className="image">
                                <img src={img1} alt="img1" />
                            </div>
                            <div className="image">
                                <img src={img1} alt="img1" />
                            </div>
                            <div className="image">
                                <img src={img1} alt="img1" />
                            </div>
                            <div className="image">
                                <img src={img1} alt="img1" />
                            </div>
                        </div>

                    </div>
                </div> */}

                    {/* <div className="image-reviews-modal-container">
                    <div className="modal-container">

                        <div className="image-wrapper">
                            <span>X</span>
                            <div className="image"><img src={img1} alt="img1" /></div>
                            <div className="button-container">
                                <div className="prev"><img src={leftArrowWhite} /></div>
                                <div className="next"><img src={rightArrowWhite} /></div>
                            </div>
                            <div className="thumb-wrapper">
                                <div className="thumb-container">
                                    <img src={img1} alt="img1" />
                                </div>
                            </div>
                        </div>

                        <div className="review-wrapper">
                            <div className="user-wrapper">
                                <div className="user-review-main">

                                    <div className="startWrapper">
                                        <div>
                                            <div>5</div>
                                            <div><img src={whiteStar} /></div>
                                        </div>
                                    </div>

                                    <div className="reviewTextWrapper">
                                        Great fit and good cotton fabric, value for money.
                                    </div>
                                </div>

                                <div className="user-review-footer">
                                    <div className="user-review-left">
                                        <span>Avneesh Kumar Pal</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div> */}

                    <div className="review-headline">Customer Reviews ({reviews.length})</div>

                    <div className="user-review-container">
                        {reviews.length > 0 ? (
                            reviews.map((review, index) => (
                                <div key={review._id || index} className="user-review-wrapper">
                                    <div className="main">
                                        <div
                                            className="review-rating-chip"
                                            data-rating={ratingChipTier(review.rating)}
                                            role="img"
                                            aria-label={`${review.rating ?? "–"} out of 5 stars`}
                                        >
                                            <span className="review-rating-chip__count">{review.rating ?? "–"}</span>
                                            <span className="review-rating-chip__star" aria-hidden="true">★</span>
                                        </div>
                                        <div className="review-body">
                                            <div className="reviewTextRwapper">
                                                {review.comment || "–"}
                                            </div>
                                            {Array.isArray(review.images) && review.images.length > 0 && (
                                                <div className="images-container">
                                                    <div className="thumb-images">
                                                        {review.images.slice(0, 4).map((image, imageIndex) => (
                                                            <div
                                                                key={imageIndex}
                                                                className={`images${imageIndex === 3 && review.images.length > 4 ? " images--has-more" : ""}`}
                                                                onClick={() => openImageModal(review.images.map(ensureImageUrl), imageIndex)}
                                                                role="button"
                                                                tabIndex={0}
                                                                onKeyDown={(e) => e.key === "Enter" && openImageModal(review.images.map(ensureImageUrl), imageIndex)}
                                                            >
                                                                <img
                                                                    src={ensureImageUrl(image)}
                                                                    alt={`Review ${index + 1}`}
                                                                />
                                                                {imageIndex === 3 && review.images.length > 4 && (
                                                                    <span className="more-images-count">+{review.images.length - 4} more</span>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="footer">
                                        <div className="footer__reviewer">
                                            <LuBadgeCheck className="footer__icon" aria-hidden />
                                            <span className="footer__text">
                                                {review.user_type && review.user_type.toLowerCase() !== "normal"
                                                    ? `Verified · ${review.user_type}`
                                                    : "Verified customer"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="mob-reviews-empty-state">No reviews yet</p>
                        )}
                    </div>
                </div>
            </div>

            {imageModalOpen && modalCurrentUrl && (
                <div className="mob-reviews-image-modal" onClick={closeImageModal} role="dialog" aria-modal="true" aria-label="Customer photos">
                    <div className="mob-reviews-image-modal__inner" onClick={(e) => e.stopPropagation()}>
                        <button
                            type="button"
                            className="mob-reviews-image-modal__close"
                            onClick={closeImageModal}
                            aria-label="Close"
                        >
                            <svg className="mob-reviews-image-modal__close-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                                <path d="M6.4 6.4l11.2 11.2M17.6 6.4L6.4 17.6" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
                            </svg>
                        </button>

                        <div className="mob-reviews-image-modal__stage">
                            <div className="mob-reviews-image-modal__main">
                                <img src={modalCurrentUrl} alt="" />
                            </div>
                            {modalImagesList.length > 1 && (
                                <div className="mob-reviews-image-modal__nav">
                                    <button
                                        type="button"
                                        className="mob-reviews-image-modal__prev"
                                        onClick={(e) => { e.stopPropagation(); if (canModalPrev) modalPrev(); }}
                                        disabled={!canModalPrev}
                                        aria-label="Previous image"
                                    >
                                        <img src={leftArrowWhite} alt="" />
                                    </button>
                                    <button
                                        type="button"
                                        className="mob-reviews-image-modal__next"
                                        onClick={(e) => { e.stopPropagation(); if (canModalNext) modalNext(); }}
                                        disabled={!canModalNext}
                                        aria-label="Next image"
                                    >
                                        <img src={rightArrowWhite} alt="" />
                                    </button>
                                </div>
                            )}
                        </div>

                        <div className="mob-reviews-image-modal__footer">
                            <div className="mob-reviews-image-modal__counter">
                                {modalCurrentIndex + 1} / {modalImagesList.length}
                            </div>
                            {modalImagesList.length > 1 && (() => {
                                const total = modalImagesList.length;
                                const maxThumbs = 6;
                                const start = total <= maxThumbs ? 0 : Math.max(0, Math.min(modalCurrentIndex - 2, total - maxThumbs));
                                const end = Math.min(start + maxThumbs, total);
                                const thumbIndices = Array.from({ length: end - start }, (_, i) => start + i);
                                return (
                                    <div className="mob-reviews-image-modal__thumbs">
                                        {thumbIndices.map((i) => (
                                            <button
                                                key={i}
                                                type="button"
                                                className={`mob-reviews-image-modal__thumb ${i === modalCurrentIndex ? "is-active" : ""}`}
                                                onClick={(e) => { e.stopPropagation(); setModalCurrentIndex(i); }}
                                                aria-label={`Image ${i + 1}`}
                                                aria-current={i === modalCurrentIndex}
                                            >
                                                <img src={modalImagesList[i]} alt="" />
                                            </button>
                                        ))}
                                    </div>
                                );
                            })()}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
